<template>
  <div class="page-bookRead" ref="box">

    <sbanner :detailInfo="detailOne" v-if="detailOne && detailOne.id" />
    <div class="bookwrap" ref="wrap" :style="{ 'width': wrapWidth }" v-if="list && list.length">
      <img :src="list[0].imgPath || pic" alt="" ref="prevImg" class="prevImg">

      <div id="flipbook" ref="bookref"
        :class="{ 'isRight': direction == 'rtl', 'showShadow': pageIndex != 1 && pageIndex != total, 'showTxt': readMode == 'txt' }"
        v-html="bookNode">
      </div>
      <div class="btn-prev" title="上一页" :class="{ 'disable': pageIndex == 1 }" @click="changePage(-1)"><span
          class="iconfont icon-arrow-lift"></span></div>
      <div class="btn-next" title="下一页"
        :class="{ 'disable': pageIndex == total || (pageIndex == total - 1 && total % 2 == 1) }" @click="changePage(1)">
        <span class="iconfont icon-arrow-right"></span></div>
    </div>
    <div class="toolbar">
      <div class="gohome" @click="goback">
        <i class="iconfont icon-arrow-left-line"></i> <span>返回</span>
      </div>
      <div class="page" @click="changeMenu">
        <i class="iconfont icon-arrow-left-right-line"></i> <span>页码</span>
      </div>
      <div class="backcate" @click="() => { bookcateShow = true }" v-if="cateLog && cateLog.length > 0">
        <i class="iconfont icon-menu-line"></i> <span>目录</span>
      </div>
      <div class="booktxt" :class="{ 'active': readMode == 'txt' }" v-if="showTxtMenu" @click="changeMode">
        <i class="iconfont icon-text"></i> <span>文本</span>
      </div>
    </div>
    <div class="page_menu" v-show="showMenu">
      <div class="btn tohome" @click="changeFirst" title="跳转第一页"><i class="iconfont icon-to-left-line"></i></div>
      <div class="btn topre" @click="changePage(-1)" title="上一页"><i class="iconfont icon-arrow-lift"></i> </div>
      <div class="input_btn" style="width:100px">
        <input type="text" id="txtpage" autocomplete="off" v-model="showPage"> <i>/</i> <span id="totalpage"
          class="totalpage">{{ total }}</span>
      </div>
      <div class="btn tonext " @click="changePage(1)" title="下一页"><i class="iconfont icon-arrow-right"></i></div>
      <div class="btn tolast" @click="changeEnd" title="跳转最后页"><i class="iconfont icon-to-right-line"></i></div>
    </div>

    <app-dialog :visible="bookcateShow" custom-class="bookPop" width="630px"
      @close="$nextTick(() => { bookcateShow = false })">
      <div class="bookCate-box">
        <BookCatelog :list="cateLog" @changePage="goOnePage" />
      </div>
    </app-dialog>
    <MaskTips />
  </div>
</template>


<script>
import { mapMutations, mapState } from 'vuex'
import BookCatelog from './components/BookCatelog.vue'
import pic from "@/assets/bookimg/1.jpg"
import Viewer from 'viewerjs'
import Sbanner from '@/components/sbanner.vue'
import AppDialog from "@/components/app-dialog";
import MaskTips from './components/maskTips.vue'
import utils from "@/utils"
import turn from "./utils/turn"

export default {
  name: 'BookRead',
  components: {
    BookCatelog,
    Sbanner,
    AppDialog,
    MaskTips
  },
  data() {
    return {
      detailOne: {},
      id: 0,
      pic,
      showpath: 'http://gdzknewcms.renrentong.cn',
      catelogId: 0,
      wrapWidth: 'auto',
      list: null,
      pageIndex: 1,
      direction: "ltr",
      startPage: 1,
      total: 0,
      showMenu: false,
      bookcateShow: false,

      cateLog: [],
      bookNode: null,
      showTxtMenu: false,
      loading: true,
      viewer: null,
      nopage: false,
      readMode: 'pic',
      fllow: null,
      showAllContent: false,
      freePage: 3,
    }
  },
  watch: {
    $route: {
      handler(newv, oldv) {
        if (newv && this.id && this.id != newv.params.id) {
          this.detailOne = {};
          this.list = null;
          this.loading = true
          this.id = newv.params.id
          this.catelogId = this.$route.query.catelogId ? this.$route.query.catelogId : '';
          this.contentId = this.$route.query.contentId ? this.$route.query.contentId : ''
          this.getOne()
        }
      }, immediate: true
    }
  },
  computed: {
    showPage: {
      get() {
        let value = this.pageIndex;
        if (value % 2 == 0) {
          if (value == this.total) {
            value = this.total
          } else {
            value = value + '-' + parseInt(value + 1)
          }
        } else {
          if (value == 1) {
            value = 1
          } else {
            value = parseInt(value - 1) + '-' + value
          }
        }
        return value
      },
      set(v) {
        if (v && v > 0) {
          this.toPage(v)
          return v
        }
      }
    },
    ...mapState(['userInfo'])
  },
  mounted() {
    this.id = this.$route.params.id;
    this.catelogId = this.$route.query.catelogId;
    this.contentId = this.$route.query.contentId
    this.showAll = this.$route.query.all == 1
    this.getOne()
    window.zoomImg = this.zoomImg
    window.stopView = this.stopView
    window.toBookLogin = this.toBookLogin
    window.addEventListener("keydown", this.KeyDown);
  },
  methods: {
    ...mapMutations(["getUserInfo"]),
    async getOne() {
      this.loading = true
      this.nopage = false
      const userInfo = utils.getCookie('login') ? JSON.parse(utils.getCookie('login')) : {}
      const params = {
        id: this.id,
        user_id: this.userInfo && this.userInfo.id ? this.userInfo.id : userInfo ? userInfo.id : 0,
        ip: window.ip,
        no_access: 0
      }
      let res = await this.$api.literatureApi.getOneById(params)
      if (res.grant == '已授权') {
        this.freePage = 99999999
      }
      const detailOne = res.data || {}

      this.detailOne = detailOne

      await this.compareContent()
      await this.getBookMenu()
      this.getBookDetails()
    },
    async compareContent() {
      await this.getUserInfo()
      this.showAllContent = this.userInfo && this.userInfo.id
    },
    async getBookMenu() {
      const res = await this.$api.literatureApi.getBookMenuById(this.id)
      const list = res.data || []
      this.cateLog = list
    },
    async getBookDetails() {
      const _t = this
      const res = await this.$api.literatureApi.getBookContentById(this.id)
      const showPath = res.showpath
      const firstRow = list && list[0] ? list[0] : {}
      this.showTxtMenu = firstRow.content && firstRow.content != 'null'

      let list = res.data || []
      list = list.map(v => {
        return {
          ...v,
          originalPath: this.setImage(showPath, v.cover_img, ``, false, 20),
          imgPath: this.setImage(showPath, v.cover_img, ``)
        }
      })

      this.allPic = list.map(v => v.imgPath)
      this.total = list.length

      let allNode = list.map((v, i) => {
        let content = v.content ? this.$utils.resetHtml(v.content) : ''

        let originalPath = v.originalPath
        if (!this.showAll) {
          if (i >= this.freePage) {
            originalPath = ''
          }
        }

        let node = `<div class="filpItem" style="background-image: url(${v.imgPath})" data-original="${originalPath}" ondblclick="zoomImg(${i})">`
        node += `   <img src="${v.imgPath}" data-original="${originalPath}" alt="aaa" class="simg" v-lazy/>`
        if (content) {
          node += `   <div class='showTxt'>${content}</div>`
        }
        // 登录阅读全文
        // if (!this.showAllContent && i > this.freePage) {
        //   node = `<div class="filpItem loginPage flex jc">`
        //   node += `   <div class='loginCon' onclick="toBookLogin()">登录阅读全文</div>`
        // }
        node += `</div>`
        return node
      })

      this.list = list
      this.bookNode = allNode.join('')

      if (!list || !list.length) {
        this.nopage = true
        this.loading = false
      }

      this.$nextTick(() => {
        this.onTurn()
        if (this.catelogId) {
          this.getBookContent(this.catelogId)
        }
        if (this.contentId) {
          let index = this.list.findIndex(t => t.contentId == this.contentId)
          if (index >= 0) {
            setTimeout(() => {
              _t.toPage(index + 1)
            }, 500);
          }
        }
        this._initViewer()
      })
    },
    _initViewer() {
      if (document.querySelector('#flipbook')) {
        this.viewer = new Viewer(document.querySelector('#flipbook'), {
          url: 'data-original',
          fullscreen: true,
          button: true,
        })
        $('#flipbook').click((e) => {
          e.preventDefault()
          e.preventDefault()
        })
      }
    },
    zoomImg(index) {
      if (this.readMode == 'txt') return;
      this.viewer.view(index)
      this.viewer.show()
    },
    // 监听键盘
    KeyDown(event) {
      const e = event || window.event || arguments.callee.caller.arguments[0];
      let key = e.keyCode;		//键盘码值 keycode
      // if(this.$refs.swiperbook.viewer && this.$refs.swiperbook.viewer.isShown) return;
      if (this.viewer && this.viewer.isShown) return
      if (key == 37) { //左
        // console.log("left");
        this.changePage(-1)
      } else if (key == 39) {	//右
        // console.log("right");
        this.changePage(1)
      }
    },


    onTurn() {
      let prevImg = this.$refs.prevImg
      if (prevImg) {
        let imgWidth = prevImg.naturalWidth || 480
        let imgHeight = prevImg.naturalHeight || 750
        if (imgWidth > imgHeight) {
          imgWidth =  480
          imgHeight =  750
        }

        let box = this.$refs.box
        let boxWidth = box.clientWidth
        let boxHeight = box.clientHeight - 100

        let mWidth = imgWidth
        let mHeight = imgHeight;
        if (imgWidth * 2 > boxWidth) {
          mWidth = boxWidth / 2 - 30
          mHeight = imgHeight / imgWidth * mWidth
        }

        if (imgHeight > boxHeight) {
          mHeight = boxHeight - 80
          mWidth = mHeight / imgHeight * imgWidth
        }

        const bookBoxWidth = Math.floor(mWidth * 2)

        this.wrapWidth = bookBoxWidth + 'px';
        this.$nextTick(() => {
          this.loading = false

          let that = this
          $("#flipbook").turn({
            autoCenter: true,
            height: mHeight,
            width: bookBoxWidth,
            direction: this.direction,
            elevation: 50,
            page: this.startPage,
            display: 'double', //显示：single=单页，double=双页，默认双页
            gradients: true, // 折叠处的光泽渐变，主要体现翻页的立体感、真实感
            when: {         //监听事件
              turning: function (e, page, view) {// 翻页前触发
                that.pageIndex = page
              },
              turned: function (e, page) { // 翻页后触发
              }
            }
          });
        })
      }
    },

    changePage(num) {
      if (num > 0) {
        if (this.showAll) {
          $('#flipbook').turn('next');
        } else {
          if (this.freePage - 1 <= this.pageIndex) {
            if (this.userInfo && this.userInfo.id) {
              this.$toastN.showToast("因版权限制，暂不支持查看")
            } else {
              this.$toastN.showToast("请登录或注册后重试！")
            }
          }
          if (this.pageIndex < this.freePage - 1) {
            $('#flipbook').turn('next');
          }
        }
      } else {
        $('#flipbook').turn('previous');
      }
    },
    changeFirst() {
      this.toPage(1)
    },
    changeEnd() {
      this.toPage(this.total)
    },

    changeMenu() {
      this.showMenu = !this.showMenu
    },
    goback() {
      let query = this.$utils.newsQuery({}, this.$route.query.subject)
      console.log('query: ', query)
      // this.$router.go(-1)
      if (window.history.length == 1) {
        this.$router.push({ path: "/index", query })
      } else {
        this.$router.go(-1)
      }
    },
    goOnePage(e) {
      console.log("点击目录", JSON.parse(JSON.stringify(e)));
      this.getBookContent(e)
    },
    //通过目录id 查找contentid或者页码
    getBookContent(catelog) {
      const _t = this
      //单独的catelogId
      let catelogObj = {}
      if (typeof (catelog) == 'string') {
        catelogObj = this.cateLog.find(t => t.id == catelog) || {}
      } else if (typeof (catelog) == 'object') {   // 页码全部信息
        catelogObj = catelog
      }
      const abs_page_number = catelogObj.abs_page_number || 1
      if (this.list) {
        if (typeof (catelog) == 'string') {
          setTimeout(() => {
            _t.toPage(abs_page_number)
          }, 100);
        } else {
          _t.toPage(abs_page_number)
        }
        this.bookcateShow = false
      }
    },
    toPage(page) {
      if (!this.showAll) {
        if (this.freePage - 1 < page) {
          if (this.userInfo && this.userInfo.id) {
            this.$toastN.showToast("因版权限制，暂不支持查看")
          } else {
            this.$toastN.showToast("请登录或注册后重试！")
          }
        }
        page = Math.min(this.freePage - 1, page)
      }
      $('#flipbook').turn('page', page);
    },
    changeMode() {
      if (this.readMode == 'pic') {
        this.readMode = 'txt'
      } else {
        this.readMode = 'pic'
      }
    },
    toBookLogin() {
      const tempRoute = this.$route.path.replace(/\//g,'-')
      let path = `/login/${tempRoute}`
      this.$router.push(path)
    },
  },
}
</script>
<style  lang="scss">
/* *{
    margin: 0;
    padding: 0;
  } */
.page-bookRead {
  .subbanner {
    position: absolute;
    width: 100%;
    padding-top: 0;

    .curpage {
      display: none;
    }

    .home-location {
      padding: 30px 0;
    }
  }


  .van-loading {
    position: fixed;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    z-index: 10;
  }
}

.bookwrap {
  margin: 0 auto;
  margin-top: 50px;
  position: relative;

  .btn-prev,
  .btn-next {
    position: absolute;
    left: -120px;
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
    color: #bbbbbb;

    &.disable {
      opacity: 0.2;
      cursor: not-allowed;
    }

    &:hover {
      color: #777;
    }

    span {
      font-size: 80px;

    }

    &.btn-next {
      left: auto;
      right: -120px;
    }
  }
}

@keyframes op {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

#flipbook {
  display: flex;
  margin: 0px auto;
  position: relative;
  animation: op 2s;

  &.showShadow {
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.2);

    &::before,
    &::after {
      content: "";
      width: 25px;
      height: 100%;
      position: absolute;
      background: #c2c2c2;
      left: -25px;
      background: url(~@/assets/bookimg/line.jpg) top center repeat-y;
      box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.2);
    }

    &::before {
      border-radius: 4px 0 0 4px;
    }

    &::after {
      left: auto;
      right: -25px;
      border-radius: 0 4px 4px 0;
    }
  }

}

.filpItem {
  background: center center no-repeat;
  background-size: 100% 100%;
  position: relative;

  &.odd,
  &.even {
    &::before {
      content: "";
      z-index: 3;
      width: 50px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: -webkit-gradient(linear, right top, left top, color-stop(0.05, rgba(0, 0, 0, 0)), color-stop(1, rgba(0, 0, 0, 0.15))) !important;
      background-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.15) 100%) !important;
      background-image: -moz-linear-gradient(right, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.15) 100%) !important;
      background-image: -ms-linear-gradient(right, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.15) 100%) !important;
      background-image: -o-linear-gradient(right, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.15) 100%) !important;
      background-image: linear-gradient(right, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.15) 100%) !important;
    }
  }

  &.even::before {
    left: auto;
    right: 0;
    background: -webkit-gradient(linear, left top, right top, color-stop(0.25, rgba(0, 0, 0, 0)), color-stop(1, rgba(0, 0, 0, 0.2))) !important;
    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.2) 100%) !important;
    background-image: -moz-linear-gradient(left, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.2) 100%) !important;
    background-image: -ms-linear-gradient(left, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.2) 100%) !important;
    background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.2) 100%) !important;
    background-image: linear-gradient(left, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.2) 100%) !important;
  }

  .isRight &.odd::before {
    left: auto;
    right: 0;
    background: -webkit-gradient(linear, left top, right top, color-stop(0.25, rgba(0, 0, 0, 0)), color-stop(1, rgba(0, 0, 0, 0.2))) !important;
    background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.2) 100%) !important;
    background-image: -moz-linear-gradient(left, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.2) 100%) !important;
    background-image: -ms-linear-gradient(left, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.2) 100%) !important;
    background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.2) 100%) !important;
    background-image: linear-gradient(left, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.2) 100%) !important;
  }

  .isRight &.even::before {
    left: 0;
    right: auto;
    background: -webkit-gradient(linear, right top, left top, color-stop(0.05, rgba(0, 0, 0, 0)), color-stop(1, rgba(0, 0, 0, 0.15))) !important;
    background-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.15) 100%) !important;
    background-image: -moz-linear-gradient(right, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.15) 100%) !important;
    background-image: -ms-linear-gradient(right, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.15) 100%) !important;
    background-image: -o-linear-gradient(right, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.15) 100%) !important;
    background-image: linear-gradient(right, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.15) 100%) !important;
  }

  .simg {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
  }

  .showTxt {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: #fff;
    color: #4b4b4b;
    z-index: 1;
    box-sizing: border-box;
    padding: 30px;
    font-size: 15px;
    line-height: 1.8;
    text-align: justify;
    overflow: hidden;
    overflow-y: auto;

    .showTxt & {
      display: block;
    }
  }
  &.loginPage {
    background-color: #FFF;
    .loginCon {
      cursor: pointer;
      color: #DB1010;
      border: 1px solid #db1010;
      font-size: 14px;
      padding: 10px 20px;
      border-radius: 80px;
      &:hover {
        opacity: .8;
      }
    }
  }
}

.page-bookRead {
  background: rgb(243, 244, 241);
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.toolbar {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 19;
  bottom: 0;
  left: 0;
  background: #222222;
  color: #fff;
  font-size: 14px;

  &>div {
    margin-right: 128px;
    cursor: pointer;

    &:hover,
    &.active {
      color: #DB1010;
    }

    &:last-child {
      margin-right: 0;
    }

    i {
      font-size: 18px;
    }
  }
}

.page_menu {
  background: rgba(34, 34, 34, 0.7);
  width: 100%;
  height: 50px;
  position: absolute;
  z-index: 19;
  bottom: 50px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid #707070;
    font-size: 18px;
    margin-right: 10px;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }

  .input_btn {
    background: #fff;
    color: #222222;
    height: 32px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 1;
    padding: 0 10px;

    input {
      min-width: 66px;
      padding-top: 2px;
      text-align: center;
      white-space: nowrap;
    }
  }
}

.prevImg {
  width: 0;
  height: 0;
  opacity: 0;
}

.bookCate-box {
  width: 600px;
  background: #fff;
  border-radius: 10px;
  padding-left: 10px;
  box-sizing: border-box;

}

.bookPop {
  .el-dialog__body {
    height: 70vh;
    padding: 0;
  }

  .el-dialog__headerbtn {
    top: 10px
  }

}</style>